import BaseUISystem from '../BaseUISystem';
import BaseMenu from './BaseMenu';
import { UIActions } from '../../../State/UI/UIActions';
import Game from '../../../Game';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import Armature from '../../../Prototype/Armature';
import { StartAnimationClip } from '../../Animation/AnimationHelper';
import { PetUnlock } from '../../Animation/Clip';
import Renderable from '../../../Component/Renderable';
import { ContextType, ResponseType } from '../../../State/Game/ContextType';
import { GameActions } from '../../../State/Game/GameActions';
import { IGameState } from '../../../State/Game/IGameState';
import UITextComponent from '../../../Component/UI/Text';
import { PetId } from '../../../Constants/Pets';
import { applyDefaultButtonAnimation } from '../UIHelper';
import { PopupID } from '../../../State/UI/PopupID';
import ElementComponent from 'Component/UI/Element';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';


export default class PetUnlockMenuHandler extends BaseMenu {
    private unlockPetArmature: Armature;
    private DBContainer: GameObject;
    private continueButtonBG: GameObject;
    private continueButton: GameObject;
    private textBox: GameObject;

    private petId: PetId;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.PET_UNLOCK_MENU, uiSystem);
    }

    public onCreate() {
        super.onCreate();

        this.continueButtonBG = this.element.find('continue_button_bg');
        this.continueButtonBG.getComponent(Renderable).visible = false;

        this.continueButton = this.continueButtonBG.findChildByName(
            'continue_button'
        );

        this.continueButton.on(GameObjectEvent.SELECTED, this.onContinue);
        applyDefaultButtonAnimation(this.continueButton);
        this.cleanupManager.add(() => {
            this.continueButton.off(GameObjectEvent.SELECTED, this.onContinue);
        });

        this.DBContainer = this.element.find('DB_container');

        this.unlockPetArmature = GameObject.Instantiate(Armature, {
            dragonbonesName: 'pet_unboxing',
            armatureName: 'Armature',
            animationName: 'start',
            playOnStart: false,
        });

        this.DBContainer.addChild(this.unlockPetArmature);

        this.textBox = this.element.find('text_box');
        this.configureShareButtonForNative();
    }

    public onShow(params: { petId: PetId }) {
        this.petId = params.petId;

        this.textBox.getComponent(Renderable).visible = false;
        this.textBox
            .find('text')
            .getComponent(UITextComponent).text = Game.locale.getText(
            `${this.petId}SharePetUnlock`
        );

        StartAnimationClip(
            new PetUnlock(this.DBContainer, {
                armature: this.unlockPetArmature,
                continueButton: this.continueButtonBG,
                textBox: this.textBox,
            })
        );
    }

    public handleStateChanged(state: IGameState): void {
        super.handleStateChanged(state);
        this.continueButtonBG.getComponent(Renderable).visible = true;
    }

    public async preload() {
        addDragonbonesResources('pet_unboxing', `${DRAGONBONES_PATH}/Pets/`)

        Game.resource.add(
            'Pets',
            'resource/graphics/sprite_sheets/pets.json'
        );

        super.preload();
    }

    private readonly onContinue = () => {
        UIActions.hidePopup(PopupID.PET_UNLOCK_MENU);
    };

    private configureShareButtonForNative() {
        this.continueButtonBG.getComponent(ElementComponent).anchors = [0.54, 0.9, 0.54, 0.9];
    }
}
